import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ZefFormBase, ZefFormsModule } from '@zerops/zef/forms';
import { AutomaticTopUpConfigDialogFormState } from '../automatic-top-up-config-dialog.form';
import { MaterialFormStackModule } from '@zerops/zerops/core/material-form-stack';
import { FormSectionModule } from '@zerops/zui/form-section';
import { ZuiSeparatorComponent } from '@zerops/zui/separator';

@Component({
  selector: 'z-automatic-top-up-config-form',
  templateUrl: './automatic-top-up-config-form.component.html',
  styleUrl: './automatic-top-up-config-form.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ZefFormsModule,
    MaterialFormStackModule,
    FormSectionModule,
    ZuiSeparatorComponent
  ]
})
export class AutomaticTopUpConfigFormComponent extends ZefFormBase<AutomaticTopUpConfigDialogFormState> {
}
